<template>
    <div>
        <div class="h1">
            <div class="form">
                <div class="lis1">
                    <input type="text" placeholder="姓名：与付款姓名一致">
                </div>
                <div class="text">注：与付款姓名一致，必填</div>
                <div class="lis2">
                    <input type="text" v-model="phone" placeholder="手机号：请输入11位手机号">
                </div>
                <div class="text">注：请输入11位手机号，必填</div>
                <div class="btns" @click="btns">
                    <img style="width: 6.8rem;margin: 0 auto;margin-top: .3rem;"
                        src="../../assets/img/market/market105/btn.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            phone: "",
        
        };
    },
    mounted() {

    },
    methods: {
        btns() {
            var re = /^1[3-9]{1}[0-9]{9}$/;;
            if (re.test(this.phone)) {
                this.$router.push({ path: "/market106" });

            } else {
                alert("请输入正确格式的手机号")
                this.phone = ""
            }
        }

    }
};
</script>
<style lang="less" scoped>
* {
    font-size: .16rem;
}

.h1 {
    width: 100%;
    height: 13.34rem;
    background: url(../../assets/img/market/market105/phone_bg.png)no-repeat center;
    background-size: 100% 100%;
    position: relative;

    .form {
        position: absolute;
        width: 6.8rem;
        top: 6.8rem;
        left: .24rem;

        .text {
            font-size: .22rem;
            color: #5D1F0B;
            margin-top: .1rem;
            margin-bottom: .2rem;
            padding-left: .3rem;
            font-weight: 600;
        }

        .lis1,
        .lis2 {
            width: 6.8rem;
            height: .96rem;
            background: url(../../assets/img/market/market105/ipt.png)no-repeat center;
            background-size: 100% 100%;

            input::-webkit-input-placeholder {
                color: #812d0f;
            }

            input::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: #812d0f;
            }

            input:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: #812d0f;
            }

            input:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: #812d0f;
            }

            input {
                width: 100%;
                height: 100%;
                border: none;
                background: none;
                outline: none;
                text-indent: .2rem;
                font-size: .3rem;
            }

        }
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/market/market105.vue